import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { AdminOrOwnerAuthGuard } from './core/guards/adminorowner-auth.guard';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  {
    path: '', component: LayoutComponent,

    children: [

      { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },

      { path: 'user', loadChildren: () => import('./user-management-pages/user-management-pages.module').then(m => m.UserManagementPagesModule), canActivate: [AuthGuard, AdminOrOwnerAuthGuard] },

    ]

  }
  // { path: '', component: LayoutComponent, loadChildren: () => import('./user-pages/user-pages.module').then(m => m.UserPagesModule), canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
